import {
  useBusinessProfileCompanySavedStreams,
  useBusinessProfileSelectedPlaylist,
  useBusinessProfileZvukPlaylistInfo,
  BusinessProfileCompanySavedStreamsType,
} from '@entities/businessProfile';

const useBusinessProfileAddPlaylistModalPresenter = () => {
  const {
    savedStreams,
    isLoading: isSavedStreamsLoading,
    called: isSavedStreamsCalled,
    request: requestSavedStreams,
  } = useBusinessProfileCompanySavedStreams();
  const { setSelectedBusinessProfilePlaylist } = useBusinessProfileSelectedPlaylist();

  const getSavedStreams = async (companyIds: string[], query?: string) => {
    const result = await requestSavedStreams(companyIds, query);

    return result as BusinessProfileCompanySavedStreamsType[];
  };
  const [getZvukPlaylistInfo, getZvukPlaylistInfoResult] = useBusinessProfileZvukPlaylistInfo();
  const { loading: getZvukPlaylistInfoLoading } = getZvukPlaylistInfoResult;

  const isSavedStreamsReady = isSavedStreamsCalled && (!isSavedStreamsLoading || savedStreams?.length !== 0);

  return {
    isSavedStreamsReady,
    savedStreams,
    isSavedStreamsLoading,
    getSavedStreams,
    setSelectedBusinessProfilePlaylist,
    getZvukPlaylistInfo,
    getZvukPlaylistInfoLoading,
  };
};

export default useBusinessProfileAddPlaylistModalPresenter;
